const months = {
  'months.short.jan': 'jan',
  'months.short.feb': 'fev',
  'months.short.mar': 'mar',
  'months.short.apr': 'abr',
  'months.short.may': 'mai',
  'months.short.jun': 'jun',
  'months.short.jul': 'jul',
  'months.short.aug': 'ago',
  'months.short.sep': 'set',
  'months.short.oct': 'out',
  'months.short.nov': 'nov',
  'months.short.dec': 'dez',
};

export default months;
